(() => {
  const body = document.body;
  if (matchMedia('(max-width: 767px)').matches) document.querySelectorAll('.sn-footer details').forEach((details) => { details.open = false; });
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format((cents || 0) / 100);
  const toggleHidden = (element, show) => {
    if (!element) return;
    element.hidden = !show;
    body.classList.toggle('sn-lock', show);
  };
  const mobileMenu = document.querySelector('[data-sn-mobile-menu]');
  document.querySelector('[data-sn-menu-open]')?.addEventListener('click', (event) => {
    toggleHidden(mobileMenu, true);
    event.currentTarget.setAttribute('aria-expanded', 'true');
  });
  document.querySelector('[data-sn-menu-close]')?.addEventListener('click', () => {
    toggleHidden(mobileMenu, false);
    document.querySelector('[data-sn-menu-open]')?.setAttribute('aria-expanded', 'false');
  });
  const cartShell = document.querySelector('[data-sn-cart-shell]');
  const closeCart = () => {
    toggleHidden(cartShell, false);
    document.querySelectorAll('[data-sn-cart-open]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
  };
  document.querySelectorAll('[data-sn-cart-close]').forEach((button) => button.addEventListener('click', closeCart));
  document.querySelectorAll('[data-sn-cart-open]').forEach((button) => button.addEventListener('click', () => {
    toggleHidden(cartShell, true);
    button.setAttribute('aria-expanded', 'true');
  }));
  const renderCart = (cart) => {
    document.querySelectorAll('[data-sn-cart-count]').forEach((node) => { node.textContent = String(cart.item_count); });
    const items = document.querySelector('[data-sn-cart-items]');
    if (items) items.innerHTML = cart.items.length ? cart.items.map((item, index) => `<article class="sn-drawer-line"><img src="${item.image || ''}" width="90" height="90" alt=""><div class="sn-drawer-line__body"><a href="${item.url}">${item.product_title}</a><small>${item.variant_title === 'Default Title' ? '' : item.variant_title}</small><strong>${money(item.final_line_price)}</strong><div class="sn-drawer-line__controls" data-sn-drawer-quantity data-line="${index + 1}"><button type="button" data-sn-drawer-minus aria-label="Decrease quantity">−</button><input type="number" min="0" value="${item.quantity}" aria-label="Quantity" data-sn-drawer-input><button type="button" data-sn-drawer-plus aria-label="Increase quantity">+</button><button class="sn-drawer-remove" type="button" data-sn-drawer-remove>Remove</button></div></div></article>`).join('') : '<p class="sn-empty">No items in cart</p>';
    const total = document.querySelector('[data-sn-cart-total]');
    if (total) total.textContent = money(cart.total_price);
  };
  document.querySelectorAll('[data-sn-product-form], [data-sn-quick-add]').forEach((form) => form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    button?.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error('Unable to add this item.');
      const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((result) => result.json());
      renderCart(cart);
      toggleHidden(cartShell, true);
      document.querySelector('[data-sn-cart-open]')?.setAttribute('aria-expanded', 'true');
    } catch (error) {
      const status = form.querySelector('[data-sn-form-status]');
      if (status) status.textContent = error.message;
    } finally {
      button?.removeAttribute('aria-busy');
    }
  }));
  document.querySelectorAll('[data-sn-quantity]').forEach((wrapper) => {
    const input = wrapper.querySelector('input');
    wrapper.querySelector('[data-sn-minus]')?.addEventListener('click', () => { input.value = Math.max(1, Number(input.value || 1) - 1); });
    wrapper.querySelector('[data-sn-plus]')?.addEventListener('click', () => { input.value = Math.max(1, Number(input.value || 1) + 1); });
  });
  const changeDrawerLine = async (line, quantity) => {
    const response = await fetch('/cart/change.js', { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ line, quantity }) });
    if (!response.ok) throw new Error('Unable to update this item.');
    renderCart(await response.json());
  };
  document.querySelector('[data-sn-cart-items]')?.addEventListener('click', async (event) => {
    const control = event.target.closest('[data-sn-drawer-minus], [data-sn-drawer-plus], [data-sn-drawer-remove]');
    if (!control) return;
    const wrapper = control.closest('[data-sn-drawer-quantity]');
    const input = wrapper?.querySelector('[data-sn-drawer-input]');
    const current = Math.max(0, Number(input?.value || 0));
    const quantity = control.hasAttribute('data-sn-drawer-remove') ? 0 : control.hasAttribute('data-sn-drawer-plus') ? current + 1 : Math.max(0, current - 1);
    wrapper?.setAttribute('aria-busy', 'true');
    try { await changeDrawerLine(Number(wrapper?.dataset.line), quantity); }
    finally { wrapper?.removeAttribute('aria-busy'); }
  });
  document.querySelector('[data-sn-cart-items]')?.addEventListener('change', async (event) => {
    const input = event.target.closest('[data-sn-drawer-input]');
    if (!input) return;
    const wrapper = input.closest('[data-sn-drawer-quantity]');
    await changeDrawerLine(Number(wrapper?.dataset.line), Math.max(0, Number(input.value || 0)));
  });
  document.querySelectorAll('[data-sn-cart-quantity]').forEach((wrapper) => {
    const input = wrapper.querySelector('input');
    wrapper.querySelector('[data-sn-cart-minus]')?.addEventListener('click', () => { input.value = Math.max(0, Number(input.value || 0) - 1); });
    wrapper.querySelector('[data-sn-cart-plus]')?.addEventListener('click', () => { input.value = Math.max(0, Number(input.value || 0) + 1); });
  });
  const productRoot = document.querySelector('[data-sn-product]');
  if (productRoot) {
    const variants = JSON.parse(productRoot.querySelector('[data-sn-variants]')?.textContent || '[]');
    const idInput = productRoot.querySelector('[name="id"]');
    const optionButtons = [...productRoot.querySelectorAll('[data-sn-option-value]')];
    const setVariant = () => {
      const selected = [...productRoot.querySelectorAll('[data-sn-option]')].map((group) => group.querySelector('[aria-pressed="true"]')?.dataset.snOptionValue);
      const variant = variants.find((candidate) => candidate.options.every((value, index) => value === selected[index]));
      if (!variant) return;
      idInput.value = variant.id;
      productRoot.querySelector('[data-sn-price]').textContent = money(variant.price);
      const compare = productRoot.querySelector('[data-sn-compare]');
      compare.textContent = variant.compare_at_price > variant.price ? money(variant.compare_at_price) : '';
      const add = productRoot.querySelector('[data-sn-add]');
      add.disabled = !variant.available;
      add.textContent = variant.available ? 'Add to cart' : 'Sold out';
      const sku = productRoot.querySelector('[data-sn-sku]');
      if (sku) sku.textContent = variant.sku ? `Model: ${variant.sku}` : '';
      if (variant.featured_media?.id) {
        const mediaButton = document.querySelector(`[data-sn-media-id="${variant.featured_media.id}"]`);
        if (mediaButton) mediaButton.click();
        else if (variant.featured_media.preview_image?.src) setMainImage(variant.featured_media.preview_image.src, variant.featured_media.alt || variant.public_title || '');
      }
      history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
    };
    optionButtons.forEach((button) => button.addEventListener('click', () => {
      button.closest('[data-sn-option]').querySelectorAll('[data-sn-option-value]').forEach((peer) => peer.setAttribute('aria-pressed', String(peer === button)));
      setVariant();
    }));
  }
  const mainImage = document.querySelector('[data-sn-main-image]');
  const mainFrame = document.querySelector('[data-sn-main-frame]');
  const setMainImage = (source, alt = '') => {
    if (!mainImage || !source) return;
    const picture = mainImage.closest('picture');
    if (picture) picture.querySelectorAll('source').forEach((candidate) => candidate.removeAttribute('srcset'));
    mainImage.removeAttribute('srcset');
    mainImage.removeAttribute('sizes');
    mainImage.setAttribute('src', source);
    if (alt) mainImage.setAttribute('alt', alt);
  };
  document.querySelectorAll('[data-sn-media-id]').forEach((button) => button.addEventListener('click', () => {
    const thumbnail = button.querySelector('img');
    setMainImage(button.dataset.snImage, thumbnail?.alt || '');
    if (mainFrame) {
      mainFrame.style.setProperty('--sn-native-width', `${Number(button.dataset.snImageWidth) || 1600}px`);
      mainFrame.style.setProperty('--sn-native-height', `${Number(button.dataset.snImageHeight) || 1600}px`);
    }
    document.querySelectorAll('[data-sn-media-id]').forEach((peer) => peer.setAttribute('aria-current', String(peer === button)));
  }));
  document.querySelectorAll('[data-sn-track]').forEach((track) => {
    const id = track.id;
    document.querySelectorAll(`[data-sn-track-prev="${id}"]`).forEach((button) => button.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth * .85, behavior: 'smooth' })));
    document.querySelectorAll(`[data-sn-track-next="${id}"]`).forEach((button) => button.addEventListener('click', () => track.scrollBy({ left: track.clientWidth * .85, behavior: 'smooth' })));
  });
})();
